import {DBConfig} from "ngx-indexed-db";

export const dbConfig: DBConfig = {
  name: 'CacheDatabase',
  version: 1,
  objectStoresMeta: [
    {
      store: 'fleet_api_cache', // Nome del database per la cache
      storeConfig: {keyPath: 'url', autoIncrement: false},
      storeSchema: [
        {name: 'url', keypath: 'url', options: {unique: true}},
        {name: 'response', keypath: 'response', options: {unique: false}},
        {name: 'responseTime', keypath: 'responseTime', options: {unique: false}},
        {name: 'tags', keypath: 'tags', options: {unique: false}}
      ]
    }
  ]
};
